import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import LoginModal from "../components/loginModal";
import SignupModal from "../components/signupModal";

const LocatingControllerId = () => {
  return (
    <React.Fragment>
      <div className="min-height-full">
        {/* ==== Header for Page ==== */}
        
        <Header parent="homePage"></Header>

        {/* ==== Hero Section ==== */}
        <div
          className="d-flex flex-column flex-center"
          style={{ backgroundColor: "#FFC000" }}
        >
          <br />
          <br />
          <br />
          <br />

      
        </div>

        {/* ==== Blog Content Section ==== */}
        <div className="mb-0" style={{ padding: "3rem 3rem 9rem" }}>
          <div className="container">
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10">
                
                {/* Blog Article Card */}
                <div
                  className="bg-white rounded p-md-5 p-3"
                  style={{
                    boxShadow:
                      "0 0 20px 0 rgb(62 57 107 / 7%), 0 2px 9px 0 rgb(62 57 107 / 6%)",
                  }}
                >
                  {/* Article Header */}
                  <div className="text-center mb-2">                                 
                    <p className="fs-5">
                    <b>You can find your Controller ID/Customer ID from either Controller UI or CoPilot UI. </b>
                    </p>
                  </div>
                  <hr className="my-4" />
                  {/* Controller Method Section */}
                  <div id="controller-method" className="mb-2">
                  
                 
                         {/* Step-by-Step Instructions */}
                      
                    <span className="mb-4 mt-4 text-center">
                   <b>From Controller UI</b>:  Controller/Customer  ID can be found from Controller UI: Settings
                    &gt; Controller &gt; License
                    </span>
                    
                    {/* Full-width Image */}
                    <div className="text-center mb-3 mt-4">
                      <img
                        src="img/avxit-controller.png"
                        alt="Aviatrix Controller Interface showing License section"
                        className="img-fluid rounded shadow"
                        style={{
                          maxHeight: "600px",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                      <p className="text-muted mt-3 small">
                        <em>Controller UI: Settings → Controller → License</em>
                      </p>
                    </div>

                 
                  </div>

                  {/* Divider */}
                  <hr className="my-4" />

                  {/* CoPilot Method Section */}
                  <div id="copilot-method" className="mb-4">
                  
                     
                    <p className="mb-4 mt-4 text-center">
                   <b>From CoPilot UI</b> : Controller/Customer  ID can be found from CoPilot UI: Settings
                    &gt; Configuration &gt; License
                    </p>
                    
                    {/* Full-width Image */}
                    <div className="text-center mb-2">
                      <img
                        src="img/avxit-copilot.png"
                        alt="Aviatrix CoPilot Interface showing License section"
                        className="img-fluid rounded shadow"
                        style={{
                          maxHeight: "600px",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                      <p className="text-muted mt-3 small">
                        <em>CoPilot UI: Settings → Configuration → License</em>
                      </p>
                    </div>

                
                  </div>

               
               
              

                

                </div>
              </div>
              <div className="col-md-1" />
            </div>
          </div>
        </div>

       {/* ==== Login Modal ==== */}
       <LoginModal></LoginModal>

{/* ==== Sign up Modal ==== */}
<SignupModal></SignupModal>
        {/* ==== Footer Component ==== */}
        <Footer></Footer>
      </div>
    </React.Fragment>
  );
};

export default LocatingControllerId;
